import { render, staticRenderFns } from "./_base-nav-category-dropdown.vue?vue&type=template&id=2c7a4fa8"
import script from "./_base-nav-category-dropdown.vue?vue&type=script&lang=js"
export * from "./_base-nav-category-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports